module.exports = __webpack_public_path__ + "img/plus.93309482.svg";